import { useState, useEffect, type ReactNode } from 'react';
import { brandingService } from '../services/brandingService';
import { logger } from '../lib/logger';
import { BrandingContext, DEFAULT_BRANDING } from './brandingContextDef';

export function BrandingProvider({ children }: { children: ReactNode }) {
  const [branding, setBranding] = useState(DEFAULT_BRANDING);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadBranding = async () => {
      try {
        const data = await brandingService.getBranding();
        setBranding(data);

        document.documentElement.style.setProperty('--brand-primary', data.primaryColor);
        document.documentElement.style.setProperty('--brand-secondary', data.secondaryColor);

        if (data.faviconUrl) {
          const faviconUrl = brandingService.getImageUrl(data.faviconUrl);
          if (faviconUrl) {
            const link = document.querySelector("link[rel*='icon']") as HTMLLinkElement || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = faviconUrl;
            document.getElementsByTagName('head')[0].appendChild(link);
          }
        }

        if (data.companyName || data.tenantName) {
          document.title = `${data.companyName || data.tenantName} - Musteri Portali`;
        }
      } catch (error) {
        logger.error('Error loading branding', error);
        setBranding(DEFAULT_BRANDING);
      } finally {
        setLoading(false);
      }
    };
    loadBranding();
  }, []);

  const getImageUrl = (url: string | null | undefined): string | null => {
    return brandingService.getImageUrl(url);
  };

  return (
    <BrandingContext.Provider value={{ branding, loading, getImageUrl }}>
      {children}
    </BrandingContext.Provider>
  );
}
